import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';

const ServiceCard = ({ icon, title, description }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="col-lg-3 col-sm-6 wow fadeInDown" data-wow-delay="0.1s">
      <div className="service-item border border-white rounded pt-3 h-100 d-flex flex-column">
        <div className="p-4 text-center d-flex flex-column justify-content-between flex-grow-1">
          <div>
            <div className="icon-box">
              <i className={`fa ${icon}`} />
            </div>
            <h5
              className="text-center"
              style={{ fontFamily: 'var(--architects-font)' }}
            >
              {title}
            </h5>
            <p className={`service-desc ${showMore ? 'expanded' : ''}`}>
              {description}
            </p>
          </div>
          <button
            className="read-more-btn mt-3"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? 'Tutup' : 'Lihat Selengkapnya'}
          </button>
        </div>
      </div>
    </div>
  );
};

function Services() {
  const serviceData = [
    {
      icon: 'fa-globe',
      title: 'Izin Resmi PIHK dan PPIU',
      description:
        'Travel kami telah memiliki izin resmi dari Kementerian Agama sebagai Penyelenggara Ibadah Haji Khusus (PIHK) dan Penyelenggara Perjalanan Ibadah Umrah (PPIU), menjamin kelegalan dan keamanan dalam setiap keberangkatan Anda.',
    },
    {
      icon: 'fa-hotel',
      title: 'Akreditasi A',
      description:
        'Dengan akreditasi A, kami membuktikan komitmen terhadap standar pelayanan terbaik, sesuai dengan evaluasi Kementerian Agama terhadap penyelenggara perjalanan umrah dan haji.',
    },
    {
      icon: 'fa-user',
      title: 'ISO 9001 2015',
      description:
        'Dengan sertifikasi ISO 9001:2015, kami memastikan pelayanan umroh & haji berjalan sesuai standar mutu internasional untuk menjamin kenyamanan dan kepuasan jamaah.',
    },
    {
      icon: 'fa-book',
      title: 'Laporan Keuangan WTP',
      description:
        'Predikat WTP mencerminkan bahwa pengelolaan dana dan operasional kami diaudit secara profesional dan terbukti transparan. Jamaah dapat beribadah dengan tenang tanpa khawatir akan keamanan dana.',
    },
    {
      icon: 'fa-users',
      title: 'Tour Leader dan Muthawif Kompeten',
      description:
        'Setiap perjalanan Anda akan didampingi oleh tour leader dan muthawif berpengalaman yang siap membimbing ibadah dan memberikan kenyamanan selama berada di Tanah Suci.',
    },
    {
      icon: 'fa-headphones',
      title: 'Transmitter/ Audio Umroh',
      description:
        'Setiap jamaah dibekali perangkat audio transmitter agar dapat mendengarkan panduan dari pembimbing ibadah dengan jelas selama kegiatan ziarah dan manasik di Mekah dan Madinah.',
    },
    {
      icon: 'fa-camera',
      title: 'Dokumentasi',
      description:
        'Kami menyediakan dokumentasi lengkap dalam bentuk foto dan video selama perjalanan, dikerjakan oleh tim profesional agar setiap momen ibadah Anda terekam indah tanpa mengganggu kekhusyukan.',
    },
    {
      icon: 'fa-cog',
      title: 'Full Service dan Handling',
      description:
        'Dari pengurusan paspor, visa, hingga keberangkatan di bandara, tim kami akan membantu seluruh kebutuhan administrasi dengan pelayanan terbaik.',
    },
  ];

  const { ref, inView: isInView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <div>
      <div className="container-xxl py-5 transparent-bg">
        <div className="container">
          <div
            ref={ref}
            className="text-center wow fadeInDown"
            data-wow-delay="0.1s"
          >
            <h6 className="section-title bg-white text-center text-primary px-3">
              Pelayanan Kami
            </h6>
            <h1 className="mb-5">
              Mengapa Harus Memilih{' '}
              <span
                className={`sanema ${isInView ? 'glowing-text' : ''}`}
                style={{ color: '#e8c04b' }}
              >
                Sanema ?
              </span>
            </h1>
          </div>
          <div className="row g-4">
            {serviceData.map((service, index) => (
              <ServiceCard
                key={index}
                icon={service.icon}
                title={service.title}
                description={service.description}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
